import { Box, useTheme } from '@mui/material';
import { ATSConnectHiringRequestRequestReferenceTestIds } from 'data-testids/ATS';
import { ToggleButtonAlignment, ToggleButtons } from 'sharedComponents/Buttons/ToggleButtons';
import { ReferenceToggleProps } from 'features/References';

export const toggleOptions = [
  { title: 'Write reference check', id: ToggleButtonAlignment.LEFT_TOGGLE_ACTIVE },
  { title: 'Request reference check', id: ToggleButtonAlignment.RIGHT_TOGGLE_ACTIVE },
];

export const ReferenceToggle: React.FC<ReferenceToggleProps> = ({
  currentlySelected,
  onToggle,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ pt: 3 }}>
      <ToggleButtons
        currentlySelected={currentlySelected}
        onToggle={onToggle}
        dataTestId={ATSConnectHiringRequestRequestReferenceTestIds.TOGGLE_BUTTONS}
        options={toggleOptions}
        sx={{
          borderRadius: 1,
          height: theme.spacing(5.25),
        }}
      />
    </Box>
  );
};
